const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
export const monthKey = value => /^\d{4}-(0[1-9]|1[0-2])$/.test(String(value || '').slice(0, 7))
  ? String(value).slice(0, 7) : null;
export const monthLabel = key => `${MONTH_NAMES[Number(key.slice(5)) - 1]} ${key.slice(0, 4)}`;

export function importMonths(batches, now = new Date()) {
  const current = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  const keys = ['2025-01', current, ...batches.flatMap(b => [b.period_month, ...(b.data_months || [])])]
    .map(monthKey).filter(Boolean).sort();
  const months = [];
  const start = Number(keys[0].slice(0, 4)) * 12 + Number(keys[0].slice(5)) - 1;
  const last = keys.at(-1);
  const end = Number(last.slice(0, 4)) * 12 + Number(last.slice(5)) - 1;
  for (let n = end; n >= start; n--) {
    const key = `${Math.floor(n / 12)}-${String(n % 12 + 1).padStart(2, '0')}`;
    months.push({ key, label: monthLabel(key) });
  }
  return months;
}
